/**
 * UUID de la antigua base de datos de Lovable y equivalencias en la base actual.
 *
 * Se conservan en el cliente para que los enlaces y configuraciones de kioscos
 * desplegados con `?id=<uuid-antiguo>` sigan funcionando después de la migración.
 */
export const CURRENT_MUNICIPALITY_IDS_BY_LEGACY_ID: Readonly<
  Record<string, string>
> = {
  // Peñarroya-Pueblonuevo
  "6ccd7075-18c9-4751-95f7-a05993810a13":
    "daab830e-1f9a-4547-b872-b4fdb36a7402",
  // Bélmez
  "8b5d4770-c397-41fc-8243-d60cce48a8b1":
    "9f259388-5d93-4563-bac1-a407da52e32b",
  // Espiel
  "25444738-fd62-4b5b-821a-aca5cf16a9c3":
    "04582bd2-5adb-42ff-95d5-35b8dd459d6f",
  // Fuente Obejuna
  "5436d7d9-cec1-425b-9d9d-85fc3ad0a324":
    "0395eaac-3954-4485-9290-b9b8fc736f12",
  // La Granjuela
  "9164a582-04ae-4543-b786-3fc05b747a87":
    "9b151904-83ee-4f8d-988e-18e3c8f94e18",
  // Los Blázquez
  "3bf67d48-a27d-44e4-a9ca-b61eed27fa02":
    "18d324d5-6c68-4591-8e37-8154f82be4a9",
  // Cerro Muriano (Obejo)
  "8132dc6f-1993-4055-888a-75ae8474293c":
    "f390a933-73c0-431c-ae7c-d8daeec2aa44",
  // Villanueva del Rey
  "bba1ab17-fd4d-43b8-95fd-13796bae4faf":
    "085ddee2-360b-48cc-8c82-fa07e944122d",
  // Villaviciosa de Córdoba
  "a5ed458d-b061-4d3b-a34b-502fb6343a7a":
    "ba3bbd51-4f04-40ca-b611-2e0532b53ec5",
  // Villaharta (no confundir con "Turismo de Villaharta")
  "5c467ca8-ba4d-4199-a586-db8454736d16":
    "001a64ee-6cb1-40c9-87c1-0349eb216b81",
  // Valsequillo
  "da9a40b2-67fb-4ba5-91da-4ba81074586e":
    "a1294c20-f332-4018-928f-31a014b5d4fb",
};

export const LEGACY_MUNICIPALITY_NAMES_BY_ID: Readonly<Record<string, string>> = {
  "6ccd7075-18c9-4751-95f7-a05993810a13": "Peñarroya-Pueblonuevo",
  "8b5d4770-c397-41fc-8243-d60cce48a8b1": "Belmez",
  "25444738-fd62-4b5b-821a-aca5cf16a9c3": "Espiel",
  "5436d7d9-cec1-425b-9d9d-85fc3ad0a324": "Fuente Obejuna",
  "9164a582-04ae-4543-b786-3fc05b747a87": "La Granjuela",
  "3bf67d48-a27d-44e4-a9ca-b61eed27fa02": "Los Blázquez",
  "8132dc6f-1993-4055-888a-75ae8474293c": "Obejo-Cerro Muriano",
  "bba1ab17-fd4d-43b8-95fd-13796bae4faf": "Villanueva del Rey",
  "a5ed458d-b061-4d3b-a34b-502fb6343a7a": "Villaviciosa de Córdoba",
  "5c467ca8-ba4d-4199-a586-db8454736d16": "Villaharta",
  "da9a40b2-67fb-4ba5-91da-4ba81074586e": "Valsequillo",
};

export const getCurrentMunicipalityIdFromLegacyId = (
  id: string | null | undefined,
): string | undefined => {
  const normalizedId = id?.trim().toLowerCase();
  return normalizedId
    ? CURRENT_MUNICIPALITY_IDS_BY_LEGACY_ID[normalizedId]
    : undefined;
};

export const getLegacyMunicipalityName = (
  id: string | null | undefined,
): string | undefined => {
  const normalizedId = id?.trim().toLowerCase();
  return normalizedId
    ? LEGACY_MUNICIPALITY_NAMES_BY_ID[normalizedId]
    : undefined;
};

export const normalizeMunicipalityName = (name: string): string =>
  name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("es")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
